import React from 'react';
import {
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { styled } from '@mui/material';

type SocialFooterProps = WithSitecoreContextProps & {
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const SocialFooter = ({ sitecoreContext }: SocialFooterProps): React.JSX.Element => {
  const FooterWrapper = styled('div')({
    background: '#17457a',
  });

  const SocialNavArea = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    padding: '3em',
    color: 'white',
  }));

  const SocialFooterHeading = styled('h1')({
    paddingTop: '1em',
    paddingLeft: '1.5em',
    fontWeight: 700,
    fontSize: '54px',
    lineHeight: '65px',
    color: '#FFFFFF',
  });

  const ApiEnergyNav = styled('div')({
    display: 'grid',
    gap: '13px',
    padding: '12px',
    gridAutoRows: 'auto',
  });

  return (
    <FooterWrapper className="social-footer">
      {sitecoreContext.pageEditing && (
        <>
          <p>SocialFooter Component Edit Mode</p>
        </>
      )}
      <SocialFooterHeading>Stay Connected</SocialFooterHeading>
      <SocialNavArea>
        <ApiEnergyNav>
          <div className="api-energy-text">
            <h5 className="color-white">API ENERGY</h5>
          </div>
          <div className="api-energy-icon">
            <ul className="social-nav first-nav">
              <li>
                <a
                  className="btn btn-reverse btn-social"
                  href="https://www.facebook.com/TheAmericanPetroleumInstitute/"
                >
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a className="btn btn-reverse btn-social" href="https://twitter.com/APIenergy">
                  <FaTwitter />
                </a>
              </li>
              <li>
                <a
                  className="btn btn-reverse btn-social"
                  href="https://www.linkedin.com/company/americanpetroleuminstitute/"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a className="btn btn-reverse btn-social" href="https://www.youtube.com/energy">
                  <FaYoutube />
                </a>
              </li>
            </ul>
          </div>
        </ApiEnergyNav>
        <div className="row api-global-nav">
          <div className="api-energy-text">
            <h5 className="color-white">API GLOBAL</h5>
          </div>
          <div className="api-energy-icon">
            <ul className="social-nav first-nav">
              <li>
                <a
                  className="btn btn-reverse btn-social"
                  href="https://www.facebook.com/TheAmericanPetroleumInstitute/"
                >
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a className="btn btn-reverse btn-social" href="https://twitter.com/APIenergy">
                  <FaTwitter />
                </a>
              </li>
              <li>
                <a
                  className="btn btn-reverse btn-social"
                  href="https://www.linkedin.com/company/americanpetroleuminstitute/"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a className="btn btn-reverse btn-social" href="https://www.youtube.com/energy">
                  <FaYoutube />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </SocialNavArea>
    </FooterWrapper>
  );
};

export default withSitecoreContext()(SocialFooter);
